import { render, staticRenderFns } from "./PersonalesGeneral.vue?vue&type=template&id=a6edb13c&lang=html&"
import script from "./PersonalesGeneral.vue?vue&type=script&lang=js&"
export * from "./PersonalesGeneral.vue?vue&type=script&lang=js&"
import style0 from "./PersonalesGeneral.vue?vue&type=style&index=0&id=a6edb13c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports